import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import './fonts/Muli-Regular.ttf'
import { initCrashReporter } from './monitoring/crashReporter'
import ErrorBoundary from './monitoring/ErrorBoundary'

// require('dotenv').config()

initCrashReporter()

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
